import React, { Fragment } from 'react';

import { RendererActionsContext } from '@atlaskit/renderer/actions';

import { EXTENSION_KEY } from '@confluence/fabric-extension-lib/entry-points/extensionConstants';
import { createMacroExtensionHandler } from '@confluence/fabric-extension-lib/entry-points/extensions-common';
import {
	RENDERER,
	getExperienceName,
	getMacroAttributesFromADFNode,
	MacroExperienceStart,
} from '@confluence/macro-tracker';
import { ExperienceTimeout } from '@confluence/experience-tracker';
import type { InlineExternalImageParams } from '@confluence/inline-external-image';
import { InlineExternalImage } from '@confluence/inline-external-image';

export const getSsrMigrationExtHandlerForRenderer = ({ contentId }) =>
	createMacroExtensionHandler((extension) => {
		if (!extension) {
			return null;
		}

		const { extensionKey, parameters } = extension;
		const attributes = getMacroAttributesFromADFNode(extension);
		const defaultProps = {
			contentId,
			mode: RENDERER,
			extensionKey,
			attributes,
			node: extension,
		};

		if (extensionKey === EXTENSION_KEY.INLINE_EXTERNAL_IMAGE) {
			const inlineExternalImageProps = parameters as InlineExternalImageParams;
			return (
				<Fragment>
					<MacroExperienceStart
						name={getExperienceName(RENDERER, extension)}
						mode={RENDERER}
						extensionKey={extensionKey}
						attributes={attributes}
						timeout={ExperienceTimeout.MACRO_LOAD}
						contentId={contentId}
					/>
					<RendererActionsContext>
						<InlineExternalImage {...inlineExternalImageProps} {...defaultProps} />
					</RendererActionsContext>
				</Fragment>
			);
		} else {
			return null;
		}
	});
